// Add your custom JS here.

(function ($) {
    $(window).on('load resize', function () {
    });
    function checkHeight(ele) {
        var h = 0;
        $(ele).each(function () {
            if ($(this).height() > h) {
                h = $(this).height();
            }
        });
        $(ele).css('height', h + 'px');
    }

    function setFullHeight() {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
    }
    
    window.addEventListener('resize', setFullHeight);
    setFullHeight();    

    $(document).ready(function () {

        $(window).on('scroll', function () {
            if ($(window).scrollTop() > 100) {
                $('.toTop').addClass('active');
            } else {
                $('.toTop').removeClass('active');
            }

            if ($(window).scrollTop() > 5) {
                $('.header').addClass('fixed');
            } else {
                $('.header').removeClass('fixed');
            }
        });

        $('.toTop').on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 'swing');
        });

        $('.menu-item-has-children').append('<button type="button" class="btnSub"><i class="far fa-angle-down"></i></button>');

        $(document).on('click', '.btnSub', function (e) {
            e.preventDefault();
            $(this).toggleClass('active').siblings('.subMenu').slideToggle(300);
        });

        $(document).on('click', '.toggleMenu', function (e) {
            e.preventDefault();
            $('.header__search').removeClass('active');
            $('.header__fixed').toggleClass('active');
        });

        $(document).on('click', '.toggleSea', function (e) {
            e.preventDefault();
            $('.header__fixed').removeClass('active');
            $('.header__search').toggleClass('active');
        });

        if ($('.fullPage').length) {
            const fullPage = new Swiper(".fullPage", {
                direction: "vertical",
                slidesPerView: 1,
                spaceBetween: 30,
                mousewheel: true,
                effect: "fade",
                speed: 500,
                parallax: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                on: {
                    slideChange: function () {
                        if (this.activeIndex !== 0) {
                            $('.header').fadeOut(300);
                        }else {
                            $('.header').fadeIn(300);
                        }

                        setTimeout(() => {
                            if($('.swiper-slide-active .homeWork__figure .figureNumber').length) {
                                $('.homeWork__figure .figureNumber').each(function() {
                                    runCounter($(this));
                                });
                            }
                        }, 800);
                    }
                }
            });
        }

        if ($('.textMarque').length) {
            const textMarque = new Swiper(".textMarque", {
                spaceBetween: 70,
                effect: 'slide',
                loop: true,
                freeMode: true,
                slidesPerView: 4,
                speed: 2000,
                autoplay: {
                    delay: 1,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false,
                    waitForTransition: true,
                    stopOnLastSlide: false,

                }
            });
        }
        
        if ($('.partnerSlider').length) {
            const partnerSlider = new Swiper(".partnerSlider", {
                spaceBetween: 0,
                effect: 'slide',
                loop: true,
                freeMode: true,
                slidesPerView: "auto",
                speed: 2000,
                autoplay: {
                    delay: 1,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false,
                    waitForTransition: true,
                    stopOnLastSlide: false,

                }
            });
        }

        // AOS.init({ disable: 'mobile' });

        function runCounter($element) {
            if (!$element.hasClass("counted")) { // Kiểm tra nếu chưa chạy
                var targetNumber = parseInt($element.html());
                $element.addClass("counted"); // Đánh dấu đã chạy
                $({ countNum: 0 }).animate({ countNum: targetNumber }, {
                    duration: 3000,
                    easing: "linear",
                    step: function () {
                        $element.text(Math.floor(this.countNum));
                    },
                    complete: function () {
                        $element.text(targetNumber);
                    }
                });
            }
        }

        if($(['data-fancybox']).length) {
            $('data-fancybox').fancybox();
        }

        $(document).on('click', '.homeService__tabs .nav-link', function(e) {
            if(!$(this).hasClass('showText')) {
                $('.homeService__tabs .nav-link.showText').removeClass('showText').find('.text').slideUp(300).hide(300);
                $(this).addClass('showText').find('.text').slideDown(300).show(300);
            } else {
                $(this).removeClass('showText').find('.text').slideUp(300).hide(300);
            }
        });
    });

    const bounceBtn = document.getElementById("bounceBtn");
    if(bounceBtn) {
        bounceBtn.addEventListener("click", function() {
            let element = document.getElementById("bounceElement");
            element.classList.remove("bounce"); // Xóa class cũ để reset hiệu ứng
            void element.offsetWidth; // Trick để restart animation
            element.classList.add("bounce"); // Thêm class để chạy animation
        });
    }

    document.addEventListener("DOMContentLoaded", function() {
        let images = document.querySelectorAll("img");
        images.forEach(function(img) {
            img.setAttribute("oncontextmenu", "return false");
            img.setAttribute("ondragstart", "return false");
        });
    });
    
})(jQuery)